import { ReadonlyVec3, vec3 } from 'gl-matrix';

/**
 * Shared visual style for ALL contouring-operation previews (margin,
 * ring, boolean, interpolation, post-processing, smoothing): the
 * operation result is rendered as an outline in this color while
 * `Environment.operationPreviewStructure` dims every other structure.
 * An operation that writes a NEW structure leaves the source visible as
 * a fainter outline for direct comparison; one that edits a structure in
 * place hides it instead, so the result is what the viewport shows (see
 * `usePostProcessingPreview`'s `hidePreviewedStructure`).
 */

/**
 * Bright green color used for operation preview contours so they
 * stand out clearly against both bright and dark structure colors.
 */
export const getPreviewColor = (_rgb: ReadonlyVec3): vec3 =>
    vec3.fromValues(0.2, 1.0, 0.4);

/** Fill alpha for preview contours (outline stays fully opaque). */
export const PREVIEW_FILL_ALPHA = 0.18;
